import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Icon } from './Icons';
import '../styles/Header.css';
import logo from '../assests/logo.png';

const Header = () => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header className="app-header">
      <div className="header-left">
        <Link to="/home" className="header-logo-link">
          <img src={logo} alt="SKYPA Systems" className="header-logo" />
        </Link>
        <div className="header-divider" />
        <span className="header-title">WorkForce Management</span>
      </div>

      <div className="header-right">
        {isAuthenticated && (
          <button className="logout-button" onClick={handleLogout} aria-label="Logout">
            <Icon.LogOut size={15} color="currentColor" />
            <span>Logout</span>
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;
